module.exports = __webpack_public_path__ + "img/dando.d17a10d4.jpg";